import React from 'react';
import './card-footer.styles.scss' ;

const CardFooter = () => (
  <div className="footer">
  </div>
)

export default CardFooter;